
import React from 'react';
import { FaTimes, FaInfoCircle, FaFileExcel } from 'react-icons/fa';
import './ToolInfoModal.css';

const ToolInfoModal = ({ isOpen, onClose, toolName, description, steps, templateLink, templateName, templates }) => {
    if (!isOpen) return null;

    return (
        <div className="tool-modal-overlay" onClick={onClose}>
            <div className="tool-modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="tool-modal-header">
                    <h3><FaInfoCircle /> {toolName} Guide</h3>
                    <button className="tool-modal-close" onClick={onClose}>
                        <FaTimes />
                    </button>
                </div>

                <div className="tool-modal-body">
                    <p className="tool-modal-description">{description}</p>

                    <div className="tool-modal-section">
                        <h4>How to Use</h4>
                        <ol className="tool-steps-list">
                            {steps.map((step, index) => (
                                <li key={index}>{step}</li>
                            ))}
                        </ol>
                    </div>

                    <div className="tool-modal-footer">
                        {(templateLink || (templates && templates.length > 0)) && (
                            <p className="template-help-text">Need a starting point? Download the template(s) below.</p>
                        )}
                        <div className="tool-templates-container">
                            {templateLink ? (
                                <a href={templateLink} download={templateName} className="btn-download-template">
                                    <FaFileExcel /> {templateName}
                                </a>
                            ) : (
                                // Support for multiple templates array [{name, link}]
                                (templates || []).map((t, i) => (
                                    <a key={i} href={t.link} download={t.name} className="btn-download-template">
                                        <FaFileExcel /> {t.name}
                                    </a>
                                ))
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ToolInfoModal;
